import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { auth } from "../services/auth";
import { useAuth } from "../services/AuthProvider";
import menuProfile from "../assets/images/menu-profile.png";
import styles from "../css/menu.module.css";
import CartIcon from "./cartIcon";

export default function Menu() {
  const [localUser, setLocalUser] = useState("");

  const location = useLocation();

  useEffect(() => {
    const data = auth().getUser();
    setLocalUser(data);
  }, [useAuth().auth]);

  const showServices = false;
  const showTestimonials = false;

  return (
    <nav className="z-20 bg-white lg:bg-transparent drop-shadow-xl rounded-xl p-5 lg:p-0">
      <ul className="flex flex-col lg:flex-row font-semibold">
        <li className="py-2 flex-none">
          <Link
            className={`${styles.menuLink} ${
              location.pathname === "/" || location.pathname === "/*" ? "text-pink-350" : ""
            } transition-all`}
            to="*"
          >
            Home
          </Link>
        </li>
        {showServices ? (
          <li className="py-2 flex-none">
            <Link
              className={`${styles.menuLink} ${
                location.pathname === "/services" ? "text-pink-350" : ""
              } transition-all`}
              to="/services"
            >
              Services
            </Link>
          </li>
        ) : null}
        <li className="py-2 flex-none">
          <Link
            className={`${styles.menuLink} ${
              location.pathname === "/blog" ? "text-pink-350" : ""
            } transition-all`}
            to="/blog"
          >
            Blog
          </Link>
        </li>
        {showTestimonials ? (
          <li className="py-2 flex-none">
            <Link
              className={`${styles.menuLink} ${
                location.pathname === "/testimonials" ? "text-pink-350" : ""
              } transition-all`}
              to="/testimonials"
            >
              Testimonials
            </Link>
          </li>
        ) : null}
        <li className="py-2 flex-none">
          <Link
            className={`${styles.menuLink} ${
              location.pathname === "/contact" ? "text-pink-350" : ""
            } transition-all`}
            to="/contact"
          >
            Contact us
          </Link>
        </li>
        <li className="hidden lg:inline-flex flex-none px-5">|</li>
        <li className="lg:flex lg:flex-none">
          <Link
            title="Cart"
            className={`${styles.menuLink} ${
              location.pathname === "/cart" ? "text-pink-350" : ""
            } transition-all hidden lg:inline-flex`}
            to="/cart"
          >
            <CartIcon />
          </Link>
        </li>
        {localUser ? (
          <>
            <li className="lg:flex lg:flex-none">
              <Link
                title="Profile"
                className={`${styles.menuLink} transition-all hidden lg:inline-flex`}
                to="/settings"
              >
                <img src={menuProfile} alt="Profile" height={40} width={40} />
              </Link>
            </li>
          </>
        ) : (
          <>
            <li className="lg:flex lg:flex-none">
              <Link
                title="Log in"
                className={`${styles.menuLink} ${
                  location.pathname === "/login" ? "text-pink-350" : ""
                } pt-2 transition-all hidden lg:inline-flex`}
                to="/login"
              >
                Log in
              </Link>
            </li>
            <li className="lg:flex lg:flex-none">
              <Link
                title="Sign up"
                className={`${styles.menuLink} ${
                  location.pathname === "/signup" ? "text-pink-350" : ""
                } ${styles.signUpBtn} transition-all hidden lg:inline-flex`}
                to="/signup"
              >
                Sign up
              </Link>
            </li>
          </>
        )}
      </ul>
    </nav>
  );
}
